 
import React from 'react'
import MenuSection from '../components/molecules/menuSection/menuSection'
import BannerHomeSection from '../components/organisms/bannerHomeSection/bannerHomeSection'
import DesignCardSection from '../components/organisms/designCardSection/designCardSection'
import FooterHomeSection from '../components/organisms/footerHomeSection/footerHomeSection'
import StickersSection from '../components/organisms/stickersSection/stickersSection'
import WallpapersSection from '../components/organisms/wallpapersSection/wallpapersSection'
import PageLayout from '../components/templates/page-layout/page-layout'

function IndexPage() {
  return (
    <PageLayout>
      <MenuSection />
      <BannerHomeSection />
      <DesignCardSection />
      <StickersSection />
      <WallpapersSection />
      <FooterHomeSection />
    </PageLayout>
  )
}

export default IndexPage
